import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Page } from "../../components";
import Box from "../../components/layout/Box";
import Button from "../../components/widgets/Button";

import PermissionModal from "../../components/widgets/PermissionModal";

import { Icon } from "../../components/widgets";
import { Link } from "react-router-dom";

import { grapejsConfig } from "../../constants/config";

import { fetchCustomTemplates } from "signoxe/actions";

import { getUsers, isFetching, getCustomTemplates } from "signoxe/selectors";

import "grapesjs/dist/css/grapes.min.css";
import grapesjs from "grapesjs";

import "./styles.scss";

import _ from "lodash";

import presetConf from "../../constants/grapeconfig";

// grapesjs.plugins.add(presetConf

import JSZip from "jszip";

class GrapejsEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      value: "",
    };
  }

  componentDidMount() {
    grapesjs.plugins.add("gjs-preset-webpage", presetConf);
    grapesjs.plugins.add("grapesjs-touch");
    console.log("Props", this.props.html);

    
    const editor = grapesjs.init(grapejsConfig(this.props.html));
    

    editor.parentComponent = this;

    editor.Panels.addPanel({
      id: "basic-actions",
      el: ".panel__basic-actions",
      buttons: [
        {
          id: "export",
          className: "button btn-open-export",
          label: "Save Asset",
          command: "save-asset",
          context: "export-template", // For grouping context of buttons from the same panel
        },
      ],
    });

    editor.Panels.removePanel("devices-c");

    const commands = editor.Commands;

    commands.add("save-asset", {
      run(editor, sender) {
        const self = editor.parentComponent;
        // console.log(editor, editor.Config.jsInHtml ? editor.getJs() : '')
        // console.log(editor.getComponents(), editor.Components.getComponents())
        // console.log('Editor JS', editor.config.jsInHtml ? editor.getJs() : '')
        // return

        self.saveTemplate(editor);
      },
      stop(editor, sender) {},
    });

    this.editor = editor;

    editor.runCommand("core:component-outline");
  }

  /*
  The solution is to use IDs on the template itself.
  So, where we want the Event name to go. We just add <h4 id="eventName">Event name placeholder</h4>

  In the frontend. i will just target where the attribute is and change the value, adding the backend value.
  then... I can zip the file.
  
  
  */

  createZip() {
    const editor = this.editor;
    console.log("Editor", editor);
    console.log("This stuff", editor.getSelected());
    console.log("The HTML WITH GET", editor.getHtml());
    const self = editor.parentComponent;

    const cHtml = _.unescape(editor.getHtml()).replaceAll("&#039;", "'");

    if (!cHtml.length) {
      return;
    }

    console.log("THE HTML", self.state.value);

    const html = `
      <!doctype html>
      <html lang="en">
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <link rel="stylesheet" href="./css/style.css">
        </head>
        <body>${cHtml}</body>
      </html>
    `;

    const css = editor.getCss();

    const zip = new JSZip();

    zip.file("index.html", html);
    zip.file("css/style.css", css);

    zip.generateAsync({ type: "blob" }).then(function (content) {
      if (self.state.value.length) {
        const name = self.state.value.toLowerCase().replace(" ", "");
        const file = new File([content], `${name}.zip`, {
          type: "application/zip",
        });
        self.setState({ file });
        self.props.upload(file, self.state.value);
      }
    });
  }

  getFile() {
    return this.state.file;
  }

  uploadZip() {}

  saveTemplate(editor) {
    this.createZip();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.current &&
      this.props.current !== "NULL" &&
      prevProps.current !== this.props.current
    ) {
      const template = _.filter(this.props.templates, (o) => {
        return o.id == this.props.current;
      });

      if (template.length && this.editor) {
        this.editor.UndoManager.undoAll();
        this.editor.setComponents(template[0].template);
      }
    }
  }

  componentWillUnmount() {
    this.editor.destroy();
  }

  render() {
    // console.log(this.props.current)
    return (
      <Page className="grape-editor-page">
        <input
          type="text"
          name="name"
          placeholder="Asset name"
          value={this.state.value}
          onChange={(e) => this.setState({ value: e.target.value })}
          style={{ maxWidth: "300px" }}
        />
        <div class="panel__top">
          <div class="panel__basic-actions"></div>
          <div class="panel__switcher"></div>
        </div>
        <div class="editor-row">
          <div class="editor-canvas">
            <div id="gjs"></div>
          </div>
          <div class="panel__right">
            <div class="layers-container"></div>
            <div class="styles-container"></div>
          </div>
        </div>
        <div id="blocks"></div>
      </Page>
    );
  }
}

export default GrapejsEditor;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/GrapejsEditor/index.js